import { ShieldCheck, Award, Leaf, Recycle, FileCheck, Building2 } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, text: "100% Data Destruction Guaranteed" },
  { icon: Award, text: "AS/NZS 5377 Certified Partners" },
  { icon: Leaf, text: "Zero Landfill Policy" },
  { icon: Recycle, text: "Secure IT Asset Disposal" },
  { icon: FileCheck, text: "ESG Reporting Included" },
  { icon: Building2, text: "Trusted Nationwide Across Australia" },
];

function MarqueeRow() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center">
          <span className="flex items-center gap-3 px-8">
            <Icon className="h-4 w-4 text-eco-dark" strokeWidth={2.2} aria-hidden />
            <span className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.18em] text-navy">
              {text}
            </span>
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-eco" aria-hidden />
        </div>
      ))}
    </div>
  );
}

export default function TrustMarquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-slate-200 bg-slate-100 py-5"
      data-testid="trust-marquee"
    >
      <div className="animate-marquee-x flex w-max">
        <MarqueeRow />
        <MarqueeRow />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-100 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-100 to-transparent" />
    </div>
  );
}
